<sb-card [loadingDelay]="1" [loading]="loading" [isCollapsed]="true" [collapsedCard]="true"
         (onCollapse)="collapseToggled($event)">
  <div card-header classes="no-border w-100" class="d-flex flex-row align-items-center w-100">
    <div>
      <h3>
        Areas
      </h3>
      <small></small>
    </div>
  </div>
  <div card-header-more>
    <div class="flex-row d-flex">
      <button class="btn btn-secondary btn-sm text-uppercase">Add</button>
    </div>
  </div>
  <div card-body>
    <div class="flex-row d-flex">
      <input [(ngModel)]="searchStr" (ngModelChange)="dosearch($event)" type="text" class="form-control"
             placeholder="{{'lang.globals.searchPlaceholder' | translate}}" aria-describedby="basic-addon2">
    </div>
    <br>
    <div class="flex-row d-flex mydropdown">
      <div [style.height.px]="259" style="overflow-y: hidden; width: 100%;">
        <button *ngFor="let result of results" ngbTooltip [sbMapTooltip]="{type: 'AreaDTO', data: [result]}"
                container="body" tooltipClass="widthFix" placement="right left" class="dropdown-item cursor-pointer"
                [ngClass]="getClass(result)" type="button" (click)="toggle(result)">
          {{getName(result)}}&nbsp;
          <br>
          <div style="font-size: smaller;">
            {{getDescription(result)}}&nbsp;
          </div>
        </button>
      </div>
    </div>
    <br>
    <div class="flex-row d-flex">
      <div class="d-flex align-items-center justify-content-between">
        <div sb-pagination *ngIf="paginationInitialized" [collectionSize]="collectionSize" [(page)]="page"
             (pageChange)="pageChange($event)" [maxSize]="maxSize" [boundaryLinks]="boundaryLinks">
        </div>
      </div>
    </div>
    <div class="flex-row d-flex">
      <div class="d-flex align-items-center justify-content-between">
        <div class="pagination__options">
          <!-- <div ngbDropdown class="d-inline-block">
          <sb-button ngbDropdownToggle classes="btn-primary">{{maxSize}} <fa-icon [icon]="'chevron-down'"></fa-icon></sb-button>
          <div ngbDropdownMenu>
            <ul class="dropdown">
              <li ngbDropdownItem *ngFor="let size of sizes" class="item" (click)="setMaxSize(size)" [ngClass]="size === maxSize ? 'active' : ''">
                {{size}}
              </li>
            </ul>
          </div>
        </div> -->
          <span class="mr-2">{{paginationString}}</span>
        </div>
      </div>
    </div>

  </div>
</sb-card>
